export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/60 to-background-50 pointer-events-none z-10"></div>

      <div className="relative z-20 w-full px-4 md:px-6 pt-20 pb-16 md:pb-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs text-accent-400 font-medium">每日更新 · 实时追踪</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
              黑料在线
              <span className="block text-primary-500 mt-1">暴走黑料 · 黑料社 · 热门系列合集</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 font-heading mt-3">
              吃瓜第一线，热点不迷路
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0">
              黑料在线⚡是专为广大吃瓜群众打造的黑料系列内容聚合平台。本站系统整理暴走黑料在线观看资源与黑料社在线观看合辑，
              每日追踪热门话题动态，覆盖娱乐圈、网红圈、社会热点等多个领域。
              所有内容按系列归类、按热度排序，让你轻松追更不遗漏。当前站内已收录超过
              <strong className="text-primary-400">2000+</strong>条黑料系列内容，
              涵盖<strong className="text-primary-400">暴走黑料</strong>、
              <strong className="text-primary-400">黑料社精选</strong>等热门品牌系列。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">2000+</div>
                <div className="text-xs text-foreground-500 mt-1">累计内容条目</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">持续追踪热点</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-500 font-heading">12+系列</div>
                <div className="text-xs text-foreground-500 mt-1">品牌专题分类</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#carousel"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即浏览热门专题
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-300 text-foreground-600 font-medium text-sm hover:border-primary-500/40 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-hashtag"></i>
                查看话题热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] overflow-hidden rounded-2xl bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20theatrical%20stage%20with%20warm%20golden%20amber%20spotlight%20cutting%20through%20darkness%2C%20abstract%20flowing%20smoke%20and%20light%20particles%20creating%20mysterious%20atmosphere%2C%20entertainment%20industry%20themed%20artistic%20composition%2C%20cinematic%20wide%20shot%20with%20high%20contrast%20dramatic%20lighting%2C%20dark%20moody%20background%20with%20striking%20warm%20golden%20and%20coral%20accents%2C%20sophisticated%20editorial%20magazine%20style%20photography%2C%20elegant%20and%20bold%20visual%20storytelling%20for%20media%20platform&width=800&height=600&seq=hero-main-2026&orientation=landscape"
                alt="黑料在线 - 暴走黑料在线观看与黑料社热门系列合集主视觉"
                title="黑料在线 - 暴走黑料与黑料社核心视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
            </div>
            <div className="mt-3 flex items-center justify-center gap-4">
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                <span className="text-xs text-foreground-500">暴走黑料系列</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                <span className="text-xs text-foreground-500">黑料社精选</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-secondary-500 text-sm"></i>
                <span className="text-xs text-foreground-500">每日吃瓜日报</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}